import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import Time from "../components/time";
import Swal from "sweetalert2";
import AddAdminBranch from "../components/addAdminBranch";
import EditAdminBranchModal from "../components/editAdminBranchModal";
import AdminNav from "../components/adNav";

const AdminBranchMaster = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [formData, setFormData] = useState({ heading: ""});



  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/admin_branchMaster");

      console.log("API Response:", response.data.ListData);
      setData(response.data.ListData);
      setFilteredData(response.data.ListData);
    } catch (error) {
      console.error("Error fetching ListData:", error);
    } finally {
      setLoading(false);
    }
  };

  
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.branchMaster_code || "").toLowerCase().includes(term) || 
    String(item.branchMaster_name || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };


  const handleDelete = async (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!"
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        Swal.fire({
          title: "Deleting...",
          text: "Please wait while we process your request.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        console.log("Deleting ID:", id); // Debugging line

        const response = await axios.delete(`https://rfs2.infraconsoft.net.in/api/admin_branchDelete/${id}`);
        console.log("Delete Response:", response.data); // Debugging line

        setData(data.filter((item) => item.fld_id !== id));
        setFilteredData(filteredData.filter((item) => item.fld_id !== id));

        Swal.fire("Deleted!", "Your record has been deleted.", "success");
      } catch (error) {
        console.error("Error deleting Admin:", error); // Full error object

        const errorMessage = error.response?.data?.message || error.message || "Unknown error";

        Swal.fire({
          title: "Error!",
          text: errorMessage,
          icon: "error",
        });
      }
    }
  });
};

  
  const openAddModal = () => {
    setIsAddModalOpen(true);
  };

  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
      const [editFormData, setEditFormData] = useState({ deptCode: "", deptName: "" });
      
      const openEditModal = (item) => {
          setEditFormData({ branchName: item.branchMaster_name, branchCode: item.branchMaster_code });
          setIsEditModalOpen(true);
      };
      
      const closeEditModal = () => {
          setIsEditModalOpen(false);
      };
    

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);



  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Branch Master - Admin</h2>
          <Time />
        </section>



        {/* Add New Button */}
        <div className="add-new-container">
        <button className="add-new-btn" onClick={() => openAddModal()}>
              <i className="fa-solid fa-plus" ></i> Add New
            </button>
        </div>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by branch"  
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
            <tr>
                <th>S.No</th>
                <th>Branch Code</th>
                <th>Branch Name</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
           <tbody>
                         {loading ? (
                           <tr>
                             <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                           </tr>
                         ) : currentData.length > 0 ? (
                           currentData.map((item, index) => (
                             <tr key={index}>
                               <td>{indexOfFirstItem + index + 1}</td>
                               <td>{item.branchMaster_code}</td>
                               <td>{item.branchMaster_name}</td>
                               <td style={{cursor: 'pointer', fontWeight: 'bold'}} onClick={() => openEditModal(item)}>Edit</td>
                               <td className="del">
                                 <i className="fa-solid fa-trash-can " onClick={() => handleDelete(item.fld_id)}></i>
                               </td>
                               
                             </tr>
                           ))
                         ) : (
                           <tr>
                             <td colSpan="6">No Data Available</td>
                           </tr>
                         )}
                       </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
      <AddAdminBranch isAddOpen={isAddModalOpen} onAddClose={closeAddModal} formData={formData}  setFormData={setFormData} fetchData={fetchData} />
      <EditAdminBranchModal isOpen={isEditModalOpen} onClose={closeEditModal} editFormData={editFormData} setEditFormData={setEditFormData}
      fetchData={fetchData} />
    </div>
  );
};

export default AdminBranchMaster;
